<template>
  <section class="top-hero"
    :class="[
      background.load === 'loading' ? 'is-loading' : '',
      background.load === 'loaded' ? 'is-loaded' : '',
    ]">
    <v-scroll-animation>
      <div class="top-hero__bg">
        <img class="top-hero__bg-img--loading" src="/choice/img/top/hero-sm.jpg" alt="">
        <transition name="animation-fade">
          <img v-show="background.load === 'loaded'" :loading="background.load = 'loaded'" class="top-hero__bg-img" src="/choice/img/top/hero.jpg" alt="">
        </transition>
      </div>

      <div class="top-hero__wrap">
        <div class="top-hero__logo">
          <img src="/choice/img/common/choice-logo-vertical.png" alt="">
        </div>
        <div class="top-hero__inner">
          <div class="top-hero__description">
            <p>
              ひととえではお人形やお道具などを自由な感性で楽しみながらシュミレーションできる新サービス、「<strong>WEB de カスタマイズ</strong>」をスタートしました。
            </p>
          </div>
          <router-link class="top-hero__link" :to="config.path.root + '/step/sizes/1'">
            <span class="top-hero__link-inner">はじめる<i class="fas fa-arrow-right"></i></span>
          </router-link>
        </div>
      </div>
    </v-scroll-animation>
  </section>
</template>



<script>
export default {
  components: {
    'v-scroll-animation': require('@/components/scroll-animation.vue').default,
  },
  data() {
    return {
      background: {
        load: 'loading',
      },
    }
  },
}
</script>



<style lang="scss">
.top-hero {
  $e: &;
  overflow: hidden;
  position: relative;
  height: 448px;
  @include breakpoints-min(md) {
    height: 640px;
  }
  &__bg {
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 110%;
    border-bottom-right-radius: 2000px 300px;
    border-bottom-left-radius: 2000px 300px;
    height: 448px;
    @include breakpoints-min(md) {
      height: 640px;
    }
  }
  &__bg-img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: auto;
    height: auto;
    min-width: 100%;
    min-height: 100%;
    max-width: inherit;
    &--loading {
      @extend #{$e}__bg-img;
      filter: blur(2px);
    }
  }
  &__wrap {
    position: relative;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
  }
  &__logo {
    display: none;
    position: absolute;
    top: 64px;
    right: 0;
    @include breakpoints-min(lg) {
      display: block;
    }
  }
  &__inner {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    transform: scale(0.9) translateX(-50%);
    background: url(/choice/img/top/bg-1.svg) no-repeat;
    background-size: 288px 292px;
    width: 288px;
    height: 292px;
    margin-top: 40px;
    margin-left: auto;
    margin-right: auto;
    @include breakpoints-min(md) {
      position: absolute;
      top: 64px;
      left: 32px;
      z-index: 2;
      background-size: 320px 324px;
      width: 320px;
      height: 324px;
      margin-top: 0;
    }
  }
  &__description {
    display: flex;
    justify-content: center;
    align-items: center;
    writing-mode: vertical-rl;
    font-family: $serif;
    font-size: 13px;
    font-weight: 500;
    line-height: 2.8;
    letter-spacing: 0.125em;
    width: 100%;
    height: 100%;
    padding: 52px 32px 32px;
    p {
      text-indent: 1em;
    }
    @include breakpoints-min(md) {
      font-size: 14px;
      font-weight: 400;
      line-height: 2.8;
      letter-spacing: 0.125em;
    }
  }
  &__link {
    display: block;
    position: absolute;
    bottom: -76px;
    left: 80px;
    font-size: 13px;
    font-weight: bold;
    letter-spacing: 0.15em;
    color: #fff;
    width: 115px;
    height: 114px;
    @include breakpoints-min(md) {
      left: -24px;
      bottom: -8px;
      width: 128px;
      height: 127px;
    }
    &::before {
      content: "";
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      height: 100%;
      background: url(/choice/img/top/bg-2.svg) no-repeat;
      background-size: 115px 114px;
      @include breakpoints-min(md) {
        background-size: 128px 127px;
      }
    }
    @include hover() {
      &::before {
        animation: top-hero-link 20s linear infinite alternate;
      }
    }
    @include active() {
      &::before {
        animation: top-hero-link 20s linear infinite alternate;
      }
    }
  }
  &__link-inner {
    display: block;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    text-align: center;
    width: 100%;
  }
  .fa-arrow-right {
    margin-left: 8px;
  }

  .scroll-animation {
    #{$e}__inner {
      transition: transform 0.75s 0.25s ease-out, opacity 0.55s 0.25s ease-out;
      opacity: 0;
      transform: scale(0.95);
    }
    #{$e}__link {
      transition: transform 0.75s 0.5s ease-out, opacity 0.55s 0.5s ease-out;
      opacity: 0;
      transform: scale(0.95);
    }
    &.is-visible {
      #{$e}__inner,
      #{$e}__link {
        transform: scale(1);
        opacity: 1;
      }
    }
  }
}

@keyframes top-hero-link {
  0% {
    transform: translate(-50%, -50%) rotate(0);
  }
  100% {
    transform: translate(-50%, -50%) rotate(720deg);
  }
}
</style>
